import api from 'api';
import { Ingredients } from 'records/Ingredient';

export const INGREDIENTS_ASYNC_ACTION_START = 'INGREDIENTS_ASYNC_ACTION_START';
export const INGREDIENTS_ASYNC_ACTION_ERROR = 'INGREDIENTS_ASYNC_ACTION_ERROR';
export const INGREDIENTS_ASYNC_UPDATE_ACTION_SUCCESS = 'INGREDIENTS_ASYNC_UPDATE_ACTION_SUCCESS';
export const INGREDIENTS_DRAGGABLE_UPDATE = 'INGREDIENTS_DRAGGABLE_UPDATE';
export const INGREDIENTS_OPTIONS_UPDATE = 'INGREDIENTS_OPTIONS_UPDATE';
export const INGREDIENTS_UPDATE_ORDINAL_SUCCESS = 'INGREDIENTS_UPDATE_ORDINAL_SUCCESS';
export const INGREDIENTS_ORDINAL_DEBOUNCE = 'INGREDIENTS_ORDINAL_DEBOUNCE';
export const INGREDIENTS_RESET_STATE = 'INGREDIENTS_RESET_STATE';
export const INGREDIENTS_UPDATE_ITEM_INTO_LIST = 'INGREDIENTS_UPDATE_ITEM_INTO_LIST';
export const INGREDIENTS_UPDATE_ITEMS_UPDATING = 'INGREDIENTS_UPDATE_ITEMS_SET_UPDATING';

function ingredientsAsyncActionStart() {
  return {
    type: INGREDIENTS_ASYNC_ACTION_START,
  };
}

function ingredientsAsyncActionError(error) {
  return {
    type: INGREDIENTS_ASYNC_ACTION_ERROR,
    error,
  };
}

function ingredientsAsyncUpdateSuccess(data) {
  return {
    type: INGREDIENTS_ASYNC_UPDATE_ACTION_SUCCESS,
    data,
  };
}

function ingredientsUpdateOrdinalSuccess() {
  return {
    type: INGREDIENTS_UPDATE_ORDINAL_SUCCESS,
  };
}

export function updateDraggableIngredients(data) {
  return {
    type: INGREDIENTS_DRAGGABLE_UPDATE,
    data,
  };
}

export function updateIngredientOptions(options) {
  return {
    type: INGREDIENTS_OPTIONS_UPDATE,
    options,
  };
}

export function resetIngredientsState() {
  return {
    type: INGREDIENTS_RESET_STATE,
  };
}

export function setUpdatingIngredientsState(updating) {
  return {
    type: INGREDIENTS_UPDATE_ITEMS_UPDATING,
    updating,
  };
}

export function getIngredients(brandId, recipeId) {
  return (dispatch, getState) => {
    dispatch(ingredientsAsyncActionStart());
    return api
      .request(`ingredient/list?brandId=${ brandId }&recipeId=${ recipeId }`, 'get')
      .then(data => {
        dispatch(ingredientsAsyncUpdateSuccess(data));
        const newIngredients = Ingredients(data);
        return newIngredients;
      })
      .catch(err => {
        dispatch(ingredientsAsyncActionError('Unable to get ingredients'));
        throw err;
      });
  };
}

export function updateIngredientOrdinals(orderedMenuItems) {
  const thunk = (dispatch, getState) => {
    
    return api.request('recipeIngredient/updateOrdinalsByIndex', 'put', orderedMenuItems)
    .then((data) => {
      dispatch(ingredientsUpdateOrdinalSuccess());
      return data;
    })
    .catch((err) => {
      dispatch(ingredientsAsyncActionError('Unable to order ingredients'));
      throw (err);
    });
  };
  thunk.meta = {
    debounce: {
      time: 500,
      key: INGREDIENTS_ORDINAL_DEBOUNCE,
    },
  };
  return thunk;
}

export function updateIngredientIntoList(data) {
  return {
    type: INGREDIENTS_UPDATE_ITEM_INTO_LIST,
    data,
  };
}
